import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { Modal } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const StyledContainer = styled.div<{
  width: string;
  height: string;
  positionX: string;
  positionY: string;
  disabled?: boolean;
}>`
  position: absolute;
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  left: ${({ positionX, width }) => `calc(${positionX} - ${width}/2)`};
  top: ${({ positionY, height }) => `calc(${positionY} - ${height}/2)`};
  background-size: 100% 100%;
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
`;

export const ImageButton = styled.div<{
  normalStateImageUrl: string;
  hoverStateImageUrl: string;
}>`
  background: ${({ normalStateImageUrl }) => `url(${normalStateImageUrl})`};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;

  &:hover {
    background: ${({ hoverStateImageUrl }) => `url(${hoverStateImageUrl})`};
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
  }
`;

const useStyles = makeStyles(() => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: '2000 !important' as any,
  },
}));

export const StyledModal = ({
  open,
  onClose,
  children,
  ...props
}: {
  children: ReactElement;
  open: boolean;
  onClose(): void;
}) => {
  const classes = useStyles();
  return (
    <Modal
      open={open}
      onClose={onClose}
      className={classes.modal}
      {...props}
    >
      {children}
    </Modal>
  );
};

export default StyledContainer;
